import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

function AboutUsPage({ isB2cPage })
{
    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10  lg: lg:tw-pl-[248px] ">
            This is the About Us Page
            <Helmet title={`About Us | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="About Us" />
            </Helmet>
        </div>
    );
}

AboutUsPage.defaultProps = {
    isB2cPage: false,
};

AboutUsPage.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default AboutUsPage;
